import React, {useState} from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Pagination } from "antd";

import SummaryContainer from "./SummaryContainer";
import SummaryHeader from "./SummaryHeader";
import LoadingIndicator from "./LoadingIndicator";


const SummaryDocumentsInner = ({
    documents,
    index,
    emptyMessage,
    onPaginationChange,
}) => (
    <div
        onMouseDown={(e) => e.stopPropagation()}
    >
        <Scrollbars style={{ height: "180px" }}>
            {documents && documents.length > 0 ? (
                <p style={{ lineHeight: 1, margin: 0 }}>
                    {documents[index - 1].text}
                </p>
            ) : (
                <p>{emptyMessage}</p>
            )}
        </Scrollbars>
        <Pagination
            current={index}
            total={documents.length}
            onChange={onPaginationChange}
            showSizeChanger={false}
            pageSize={1}
        />
    </div>
);

const SummaryDocuments = ({ header, loading, documents }) => {
    const [documentsIndex, setDocumentsIndex] = useState(1);

    return (
        <SummaryContainer>
            <SummaryHeader>{header}</SummaryHeader>
            {loading ? (
                <LoadingIndicator />
            ) : (
                <SummaryDocumentsInner
                    documents={documents}
                    index={documentsIndex}
                    emptyMessage="no documents found"
                    onPaginationChange={(index) => setDocumentsIndex(index)}
                />
            )}
        </SummaryContainer>
    );
};

export default SummaryDocuments;
